const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;
export const ImageSearchV2ServiceQuery: any = {
    getImageV2Datas: Backofficebff + '/v1/imageSearchV2/getimages',
};
